/** One legacy GOT report: filter box, then the output (map §7, Appendix D). */
import { GOT_REPORT_PERMISSION, type Permission } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { gotReport } from "@/features/got/reports/defs";
import { GotReportPage } from "@/features/got/reports/reports-page";
import { DATE_MODES } from "@/lib/dates";

const search = z.object({
  run: z.boolean().optional(),
  dates: z.enum(DATE_MODES).optional().catch(undefined),
  from: z.string().optional(),
  to: z.string().optional(),
  cropId: z.number().int().optional(),
  varietyId: z.number().int().optional(),
  on: z.string().optional(),
  stage: z.string().optional(),
  result: z.string().optional(),
  age: z.number().int().optional(),
  personId: z.number().int().optional(),
  dCrop: z.string().optional(),
  dVariety: z.string().optional(),
});

export const Route = createFileRoute("/_app/quality/got/reports/$key")({
  validateSearch: search,
  beforeLoad: ({ params }) => {
    if (!gotReport(params.key)) throw redirect({ to: "/quality/got/reports" });
    const code = (GOT_REPORT_PERMISSION as Record<string, Permission>)[
      params.key
    ];
    if (!code || !useAuth.getState().can(code))
      throw redirect({ to: "/quality/got/reports" });
  },
  component: Page,
});

function Page() {
  const { key } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const def = gotReport(key)!;
  return (
    <GotReportPage
      key={key}
      def={def}
      search={s}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
